import * as React from "react";

class StartDatePopover extends React.Component<any, any> {
  render() {
    return (
      <div className="start-date-popover">
        <p>
          <strong>Start Date:</strong> Data is generated daily for the previous
          day. <br />
        </p>
      </div>
    );
  }
}
export default StartDatePopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageTwo/ReportSchedule/StartDatePopover.tsx